import { Component, OnInit, forwardRef } from '@angular/core';
import {
  NavController,
  NavParams,
  ModalController,
  IonicModule,
} from '@ionic/angular';
import { GrupoProvider } from 'src/app/services/grupo/grupo';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Browser } from '@capacitor/browser';
import { TranslateModule } from '@ngx-translate/core';
import { DateFormatPipe } from 'src/app/pipes/date-format/date-format';
import { ImagePipe } from 'src/app/pipes/image/image';
import { SafeHtmlPipe } from 'src/app/pipes/safe-html/safe-html';
import { LoadingSpinnerComponent } from 'src/app/components/loading/loading-spinner/loading-spinner.component';
@Component({
  selector: 'app-grupo-mensagem',
  templateUrl: './grupo-mensagem.page.html',
  styleUrls: ['./grupo-mensagem.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    SafeHtmlPipe,
    ImagePipe,
    LoadingSpinnerComponent,
    DateFormatPipe
  ],
})
export class GrupoMensagemPage implements OnInit {
  mensagem: any = {};
  idGrupo = '';
  idMensagem = '';
  loaded = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public grupoProvider: GrupoProvider
  ) {
    this.idGrupo = this.navParams.get('idGrupo');
    this.idMensagem = this.navParams.get('idMensagem');

    this.grupoProvider
      .getMensagem(this.idMensagem, this.idGrupo)
      .subscribe((data) => {
        this.mensagem = data;

        setTimeout(() => {
          this.loaded = true;
        }, 1000);
      });
  }

  ngOnInit() {}

  dismiss() {
    this.modalCtrl.dismiss(this.mensagem.dataLido);
  }

  public closeModal() {
    this.modalCtrl.dismiss(this.mensagem.dataLido);
  }

  async openLink(link: { target: string; url: string }) {
    await Browser.open({ url: link.url });
  }
}
